/* eslint-disable */
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import 'contents/assets/scss/page/teacher.scss';
function TeacherPreparing() {
  return (
    <main className="com_container p_mentoring_nanage">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_9">
            멘토링
            <span className="bar"></span>
            <span className="point_txt">멘토관리</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
              <div>
                <input type="search" placeholder="멘토명" className="input s type_search" />
              </div>
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">일반멘토</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">특별멘토 </label>
                </div>
              </div>
              <button className="com_btn gray s">등록</button>
            </div>
            <hr className="com_divider" />
            <div className="board_wrap_row">
              <div className="board_wrap com_board_list__scroll">
                <table className="com_board_list">
                  <colgroup>
                    <col width="70" />
                    <col width="70" />
                    <col width="160" />
                    <col width="160" />
                    <col width="auto" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th colSpan={5}>일반 멘토</th>
                    </tr>
                    <tr>
                      <th>
                        <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
                        <label htmlFor="chkAll"></label>
                      </th>
                      <th>No.</th>
                      <th>등록일</th>
                      <th>멘토명</th>
                      <th>전화번호</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                      return (
                        <tr key={idx}>
                          <td>
													<input type="checkbox" name="chk1" id={`chk${idx + 1}`}  className="com_chk" />
													<label htmlFor={`chk${idx + 1}`}></label>
                          </td>
                          <td>{idx + 1}</td>
                          <td>2023,05, 10</td>
                          <td>홍길동101</td>
                          <td>010-1234-1324</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="board_wrap com_board_list__scroll">
                <table className="com_board_list">
                  <colgroup>
                    <col width="70" />
                    <col width="70" />
                    <col width="160" />
                    <col width="160" />
                    <col width="auto" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th colSpan={5}>특별 멘토</th>
                    </tr>
                    <tr>
                      <th>
                        <input type="checkbox" name="chk" id="chk2All" className="com_chk" />
                        <label htmlFor="chk2All"></label>
                      </th>
                      <th>No.</th>
                      <th>등록일</th>
                      <th>멘토명</th>
                      <th>전화번호</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                      return (
                        <tr key={idx}>
                          <td>
                            <input type="checkbox" name="chk2" id={`chk${idx + 10}`}  className="com_chk" />
                            <label htmlFor={`chk${idx + 10}`}></label>
                          </td>
                          <td>{idx + 1}</td>
                          <td>2023,05, 10</td>
                          <td>홍길동101</td>
                          <td>010-1234-1324</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">선택한 멘토 삭제</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}
export default TeacherPreparing;
